import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { validationResponseSchema } from "./validation-schemas";

export const deleteShippingMethod = {
  name: "deleteShippingMethod" as const,
  input: z.object({
    checkoutExperienceId: zExt.objectId(),
    shippingMethodId: zExt.objectId(),
    skipValidation: z.boolean().optional(),
  }),
  output: validationResponseSchema,
};
